import * as React from 'react';
import { SaveContext } from "./SaveContext.js";
export var SaveContextProvider = function (_a) {
    var children = _a.children, value = _a.value;
    return (React.createElement(SaveContext.Provider, { value: value }, children));
};
//# sourceMappingURL=SaveContextProvider.js.map